import { BrowserClient, Hub, Severity } from '@sentry/browser';
const client = new BrowserClient({
    dsn: 'https://7f116e744da34fbfa2c3879c28e4de97@sentry-next.wixpress.com/1424',
    attachStacktrace: true,
});
export const hub = new Hub(client);
const SHOULD_LOG_TO_SENTRY = process.env.NODE_ENV === 'production' && !global?.isStorybook;
let logMessageCounter = 0;
export function logMessage(message, data) {
    const numberedMessage = `[${++logMessageCounter}] ${message}`;
    if (SHOULD_LOG_TO_SENTRY) {
        hub.withScope((scope) => {
            scope.setExtra('extra_data', data);
            hub.captureMessage(numberedMessage, Severity.Debug);
        });
    }
    console.debug(numberedMessage, '\n', data);
}
export function logTaggedMessage(tags) {
    return (message, data) => {
        hub.withScope((scope) => {
            setTags(tags, scope);
            logMessage(message, data);
        });
    };
}
// Workaround for Sentry@4.
// Here instead of setTags and setExtras from Sentry@5 we use
// setTag and setExtra from Sentry@4 in order to avoid this issue.
export function setTags(tags, scope) {
    if (scope.setTags) {
        scope.setTags(tags);
    }
    for (const [key, value] of Object.entries(tags)) {
        scope.setTag(key, value);
    }
}
//# sourceMappingURL=reporter.js.map